module.exports = __webpack_public_path__ + "static/media/finestar.7a60127b.svg";